// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4decb1a5","455":"72843de3","977":"fb2bacaf"}[chunkId] + ".chunk.js";
};